import React from 'react';
import { CheckIcon } from 'lucide-react';
import { images, transformations } from '../data/landing';
export function TransformationSection() {
  return <section className="w-full bg-white py-20 lg:py-24" data-id="element-175" data-mp="31unp2q00bhjj">
      <div className="mx-auto max-w-content px-6" data-id="element-176" data-mp="2wwm7yam55sap">
        <h2 className="max-w-3xl font-display text-3xl font-bold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-177" data-mp="2wzgtk5gw5j5p">
          De ser un “instructor que corre” a ser un{' '}
          <span className="text-nature-dark" data-id="element-178" data-mp="2nya7zhzdxi5l">Entrenador Referente</span>.
        </h2>

        <div className="mt-12 grid grid-cols-1 gap-10 lg:grid-cols-[1fr_0.85fr] lg:items-start lg:gap-16" data-id="element-179" data-mp="2j5h5z1vawnx7">
          <ul className="grid grid-cols-1 gap-x-10 gap-y-7 sm:grid-cols-2" data-id="element-180" data-mp="2e7nvhwmyt7r4">
            {transformations.map(item => <li key={item.title} className="flex gap-4" data-id="element-181" data-mp="2968bm7wix7ab">
                <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-nature-soft" data-id="element-182" data-mp="247oq28ludxih">
                  <CheckIcon className="h-4 w-4 text-nature-dark" strokeWidth={3} aria-hidden="true" data-id="element-183" data-mp="2086ew4jtp0su" />
                </span>
                <div data-id="element-184" data-mp="k33v6r1wji35">
                  <h3 className="font-display text-lg font-bold text-ink" data-id="element-185" data-mp="5cwk4we851ch">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-base leading-relaxed text-ink-soft" data-id="element-186" data-mp="ab7ur9ccffvr">
                    {item.description}
                  </p>
                </div>
              </li>)}
          </ul>

          <figure className="overflow-hidden rounded-[2rem]" data-id="element-187" data-mp="12zltjrb9ag8d">
            <img src={images.group1} alt="Grupo de corredores adultos entrenando juntos en un parque por la mañana" className="h-72 w-full object-cover lg:h-[26rem]" width={1200} height={800} data-id="element-188" data-mp="p0vrrydhrsdo" />
          </figure>
        </div>
      </div>
    </section>;
}